/* reviews.js — Reviews widget JavaScript */
/* globals: REVIEWS_API */

(function () {
  'use strict';

  var API = (typeof window !== 'undefined' && window.REVIEWS_API) || '';

  /* ── State per product ──────────────────────────────────────────────── */
  var _state = {};

  function getState(productId) {
    if (!_state[productId]) {
      _state[productId] = { page: 1, rating: null, sort: 'photos_first', verifiedOnly: false, hasPhotos: false };
    }
    return _state[productId];
  }

  /* ── Stars helper ───────────────────────────────────────────────────── */
  function starsHtml(r, size) {
    var s = size || 16;
    var filled = '<span class="rv-star rv-star--filled" style="font-size:' + s + 'px">★</span>';
    var empty  = '<span class="rv-star rv-star--empty"  style="font-size:' + s + 'px">★</span>';
    var html = '';
    for (var i = 1; i <= 5; i++) html += i <= r ? filled : empty;
    return '<span class="rv-stars">' + html + '</span>';
  }

  /* ── Format date ────────────────────────────────────────────────────── */
  function fmtDate(iso) {
    try {
      var d = new Date(iso);
      var now = Date.now();
      var diff = now - d.getTime();
      var days = Math.floor(diff / 86400000);
      if (days < 1)   return 'Today';
      if (days === 1) return 'Yesterday';
      if (days < 14)  return days + ' days ago';
      if (days < 60)  return Math.floor(days / 7) + ' weeks ago';
      // Anything older than 2 months: just show month + year, no relative label
      return d.toLocaleDateString('en-SG', { year: 'numeric', month: 'short' });
    } catch (e) { return ''; }
  }

  /* ── Avatar initials ────────────────────────────────────────────────── */
  var _avatarPalette = ['#063148','#1a6b5c','#7b3f6e','#8b4513','#2e6da4','#c0562b','#4a7c59','#5c4a8b'];
  function avatarHtml(name) {
    var initials = (name || '?').trim().split(/\s+/).map(function(w){ return w[0]; }).join('').slice(0,2).toUpperCase();
    var idx = name.charCodeAt(0) % _avatarPalette.length;
    return '<div class="rv-card__avatar" style="background:' + _avatarPalette[idx] + '">' + esc(initials) + '</div>';
  }

  /* ── Init a widget ──────────────────────────────────────────────────── */
  window.rvInit = function (productId) {
    var widgetEl = document.getElementById('rv-widget-' + productId);
    if (!widgetEl) return;
    var api = widgetEl.dataset.api || API;
    if (!api) { widgetEl.style.display = 'none'; return; }
    var collectionId = widgetEl.dataset.collectionId || '';
    var groupId      = widgetEl.dataset.groupId || '';
    var showDate     = widgetEl.dataset.showDate   !== 'false';
    var photoFirst   = widgetEl.dataset.photoFirst !== 'false';  // default true
    var truncate     = widgetEl.dataset.truncate   !== 'false';  // default true
    var perPage      = parseInt(widgetEl.dataset.perPage, 10) || 8;
    var defaultSort  = widgetEl.dataset.defaultSort || 'photos_first';
    _state[productId] = _state[productId] || { page: 1, rating: null, sort: defaultSort, verifiedOnly: false, hasPhotos: false };
    _state[productId].api        = api;
    _state[productId].collectionId = collectionId;
    _state[productId].groupId    = groupId;
    _state[productId].showDate   = showDate;
    _state[productId].photoFirst = photoFirst;
    _state[productId].truncate   = truncate;
    _state[productId].perPage    = perPage;
    rvLoad(productId);
    rvLoadSummary(productId, api);
    rvLoadJsonLd(productId, api);
  };

  /* ── Load reviews ───────────────────────────────────────────────────── */
  window.rvLoad = function (productId) {
    var s = getState(productId);
    var api = s.api || API;

    // Priority: group_id > collection_id > product_id
    // If a group_id is set, use it directly (no fallback needed — API handles empty groups)
    var idParam;
    if (s.groupId && s.groupId !== '0' && s.groupId !== '') {
      idParam = 'group_id=' + s.groupId;
    } else {
      var useCollection = !s._productFallback &&
        (s.collectionId && s.collectionId !== '0' && s.collectionId !== '');
      idParam = useCollection
        ? 'collection_id=' + s.collectionId
        : 'product_id=' + productId;
    }

    var qs = idParam +
      '&page=' + s.page +
      '&per_page=' + (s.perPage || 8) +
      '&sort=' + s.sort +
      (s.rating ? '&rating=' + s.rating : '') +
      (s.verifiedOnly ? '&verified_only=true' : '') +
      (s.hasPhotos ? '&has_photos=true' : '');

    var listEl = document.getElementById('rv-list-' + productId);
    if (listEl) listEl.innerHTML = '<div class="rv-loading">Loading reviews…</div>';

    fetch(api + '/api/reviews?' + qs)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // If collection query returned nothing, silently retry by product_id
        if (data.total === 0 && useCollection) {
          s._productFallback = true;
          rvLoad(productId);
          return;
        }
        rvRender(productId, data, api);
      })
      .catch(function () {
        if (listEl) listEl.innerHTML = '<div class="rv-empty">Unable to load reviews.</div>';
      });
  };

  /* Horizontal review strip — same interaction model as the homepage carousel:
     drag to pan, slow auto-drift, pauses on hover/touch/wheel. Re-runs after
     every render (filter, sort, page change), so listeners are bound once per
     wrapper and tracked with a flag. */
  function rvInitCarousel(productId) {
    var wrap = document.getElementById('rv-carousel-' + productId);
    if (!wrap || wrap.dataset.rvCarouselBound === '1') return;
    wrap.dataset.rvCarouselBound = '1';

    var dragging = false, startX = 0, startLeft = 0;
    wrap.addEventListener('mousedown', function (e) {
      dragging = true; startX = e.pageX; startLeft = wrap.scrollLeft;
      wrap.style.cursor = 'grabbing'; e.preventDefault();
    });
    document.addEventListener('mouseup', function () {
      dragging = false; wrap.style.cursor = 'grab';
    });
    wrap.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      wrap.scrollLeft = startLeft - (e.pageX - startX);
    });

    var paused = false, resumeTimer = null;
    function pause(ms) {
      paused = true;
      clearTimeout(resumeTimer);
      if (ms) resumeTimer = setTimeout(function () { paused = false; }, ms);
    }
    wrap.addEventListener('mouseenter', function () { pause(); });
    wrap.addEventListener('mouseleave', function () { paused = false; });
    wrap.addEventListener('touchstart', function () { pause(); }, { passive: true });
    wrap.addEventListener('touchend',   function () { pause(2000); }, { passive: true });
    wrap.addEventListener('wheel',      function () { pause(2000); }, { passive: true });
    /* Don't fight a keyboard user tabbing through cards — but do resume once
       focus leaves, or the strip stops for good the first time a card button
       is focused. */
    wrap.addEventListener('focusin',  function () { pause(); });
    wrap.addEventListener('focusout', function () { paused = false; });

    /* Position is kept in a float and assigned, rather than incremented on
       scrollLeft directly. scrollLeft reads back rounded, so incrementing it
       compounds that rounding into the drift speed; holding the real position
       separately keeps it steady and lets a drag resync cleanly below. */
    var SPEED = 0.6;   /* matches the homepage strip */
    var pos = 0;
    function step() {
      if (!paused && wrap.scrollWidth > wrap.clientWidth) {
        pos += SPEED;
        if (pos + wrap.clientWidth >= wrap.scrollWidth - 2) pos = 0;
        wrap.scrollLeft = pos;
      } else {
        /* Resync after a drag or a manual scroll so it carries on from there. */
        pos = wrap.scrollLeft;
      }
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function rvRender(productId, data, api) {
    /* Aggregate */
    var scoreEl = document.getElementById('rv-score-' + productId);
    var starsEl = document.getElementById('rv-agg-stars-' + productId);
    var countEl = document.getElementById('rv-count-' + productId);
    if (scoreEl) { scoreEl.textContent = data.avg_rating.toFixed(1); scoreEl.classList.remove('rv-skeleton'); }
    if (starsEl) { starsEl.innerHTML = starsHtml(Math.round(data.avg_rating), 20); starsEl.classList.remove('rv-skeleton'); }
    if (countEl) { countEl.textContent = data.total + ' review' + (data.total !== 1 ? 's' : '') + (data.photo_count ? ' · ' + data.photo_count + ' with photos' : ''); countEl.classList.remove('rv-skeleton'); }

    /* Star distribution bars — clickable to filter */
    var distEl = document.getElementById('rv-dist-' + productId);
    if (distEl) {
      var s0 = getState(productId);
      distEl.innerHTML = [5, 4, 3, 2, 1].map(function (star) {
        var n = (data.rating_distribution && data.rating_distribution[String(star)]) || 0;
        var pct = data.total ? Math.round(n / data.total * 100) : 0;
        var active = s0.rating === star;
        return '<button class="rv-dist__row' + (active ? ' rv-dist__row--active' : '') + '" onclick="rvFilter(\'' + productId + '\',' + star + ',null)" title="Filter to ' + star + '-star reviews">' +
          '<span class="rv-dist__label">★' + star + '</span>' +
          '<div class="rv-dist__bar-bg"><div class="rv-dist__bar" style="width:' + pct + '%"></div></div>' +
          '<span class="rv-dist__n">' + n + '</span>' +
        '</button>';
      }).join('');
    }

    /* Show toolbar if there are reviews */
    var toolbar = document.getElementById('rv-toolbar-' + productId);
    if (toolbar && data.total > 0) toolbar.style.display = 'flex';

    /* Review list */
    var listEl = document.getElementById('rv-list-' + productId);
    if (!listEl) return;
    if (!data.reviews.length) {
      listEl.innerHTML = '<div class="rv-empty">No reviews yet — be the first!</div>';
    } else {
      var st = getState(productId);
      listEl.innerHTML = data.reviews.map(function (r) {
        return buildCard(r, api, st.showDate !== false, st.photoFirst !== false, st.truncate !== false);
      }).join('');
    }

    /* Carousel behaviour, when the section is rendering as a strip */
    rvInitCarousel(productId);

    /* Pagination */
    var pagEl = document.getElementById('rv-pagination-' + productId);
    if (pagEl) {
      pagEl.innerHTML = '';
      var s = getState(productId);
      for (var p = 1; p <= data.total_pages; p++) {
        (function (page) {
          var btn = document.createElement('button');
          btn.className = 'rv-page-btn' + (page === s.page ? ' active' : '');
          btn.textContent = page;
          btn.addEventListener('click', function () { s.page = page; rvLoad(productId); window.scrollTo({ top: document.getElementById('rv-widget-' + productId).offsetTop - 80, behavior: 'smooth' }); });
          pagEl.appendChild(btn);
        })(p);
      }
    }
  }

  function buildCard(r, api, showDate, photoFirst, truncate) {
    var verified     = r.is_verified_purchase ? '<span class="rv-verified-badge">✓ Verified</span>' : '';
    var verifiedIcon = r.is_verified_purchase ? '<span class="rv-verified-icon" title="Verified purchase">✓</span>' : '';
    var dateHtml     = (showDate !== false) ? '<span class="rv-card__date">' + fmtDate(r.created_at) + '</span>' : '';

    /* Product badge removed — self-explanatory on product page */
    var productBadge = '';

    /* ── Review title ── */
    var title = r.title ? '<div class="rv-card__title">' + esc(r.title) + '</div>' : '';

    /* ── Review body with truncation ── */
    var body = '';
    if (r.body) {
      var clamp    = (truncate !== false && r.body.length > 220) ? ' rv-card__body--clamped' : '';
      var readMore = clamp ? '<button class="rv-read-more" onclick="rvToggleBody(this)">Read more</button>' : '';
      body = '<div class="rv-card__body' + clamp + '">' + esc(r.body) + '</div>' + readMore;
    }

    /* ── Attribute chips ── */
    var attrs = '';
    if (r.attributes && r.attributes.length) {
      attrs = '<div class="rv-card__attrs">' +
        r.attributes.map(function(a) {
          return '<span class="rv-attr-chip">' +
            '<span class="rv-attr-chip__label">' + esc(a.attribute_label || a.attribute_name) + '</span>' +
            '<span class="rv-attr-chip__val">' + esc(a.attribute_value) + '</span>' +
          '</span>';
        }).join('') +
      '</div>';
    }

    /* ── Owner reply ── */
    var reply = '';
    if (r.reply) {
      reply = '<div class="rv-card__reply">' +
        '<div class="rv-card__reply-label"><span class="rv-card__reply-icon">💬</span>' + esc(r.reply.author_name) + ' replied</div>' +
        '<div class="rv-card__reply-body">' + esc(r.reply.body) + '</div>' +
      '</div>';
    }

    /* ── Helpful row ── */
    var helpful =
      '<div class="rv-card__helpful">' +
        '<span class="rv-helpful-label">Helpful?</span>' +
        '<button class="rv-helpful-btn" onclick="rvVoteHelpful(' + r.id + ',true,\'' + esc(api||'') + '\',this)">👍 ' + r.helpful_count + '</button>' +
        '<button class="rv-helpful-btn" onclick="rvVoteHelpful(' + r.id + ',false,\'' + esc(api||'') + '\',this)">👎 ' + r.not_helpful_count + '</button>' +
      '</div>';

    /* ── Photos ── */
    var photos = r.media ? r.media.filter(function(m){ return m.media_type === 'photo'; }) : [];
    var videos  = r.media ? r.media.filter(function(m){ return m.media_type === 'video'; }) : [];

    /* ── Photo-first layout (review has at least one photo, and setting enabled) ── */
    if (photos.length > 0 && photoFirst !== false) {
      var hero = photos[0];
      var extraPhotos = photos.slice(1);
      var heroCountBadge = photos.length > 1
        ? '<span class="rv-card__hero-count">📷 ' + photos.length + '</span>'
        : '';
      var heroHtml =
        '<button class="rv-card__hero-btn" onclick="rvPhotoExpand(\'' + esc(hero.url) + '\',' + r.id + ')" aria-label="View photo">' +
          '<img class="rv-card__hero-img" src="' + esc(hero.thumbnail_url || hero.url) + '" alt="Review photo" loading="lazy">' +
          heroCountBadge +
        '</button>';

      /* Remaining photos + videos as small grid */
      var moreMedia = '';
      if (extraPhotos.length || videos.length) {
        var items = extraPhotos.map(function(m) {
          return '<button class="rv-card__photo-btn" onclick="rvPhotoExpand(\'' + esc(m.url) + '\',' + r.id + ')" aria-label="View photo">' +
            '<img src="' + esc(m.thumbnail_url || m.url) + '" alt="" loading="lazy">' +
          '</button>';
        }).concat(videos.map(function(m) {
          return '<div class="rv-card__photo-btn rv-card__photo-btn--video">' +
            '<video src="' + esc(m.url) + '" muted playsinline preload="none"></video>' +
            '<span class="rv-card__video-play">▶</span>' +
          '</div>';
        }));
        moreMedia = '<div class="rv-card__photos">' + items.join('') + '</div>';
      }

      var contentHtml =
        '<div class="rv-card__author-row">' +
          '<span class="rv-card__author">' + esc(r.customer_name) + '</span>' +
          verifiedIcon +
        '</div>' +
        '<div class="rv-card__stars-row">' +
          starsHtml(r.rating, 13) +
          dateHtml +
        '</div>' +
        productBadge + title + body + attrs + moreMedia + reply + helpful;

      return '<div class="rv-card rv-card--has-photo" data-review-id="' + r.id + '">' +
        heroHtml +
        '<div class="rv-card__content">' + contentHtml + '</div>' +
      '</div>';
    }

    /* ── Text-only layout ── */
    var videoHtml = '';
    if (videos.length) {
      videoHtml = '<div class="rv-card__photos">' + videos.map(function(m) {
        return '<div class="rv-card__photo-btn rv-card__photo-btn--video">' +
          '<video src="' + esc(m.url) + '" muted playsinline preload="none"></video>' +
          '<span class="rv-card__video-play">▶</span>' +
        '</div>';
      }).join('') + '</div>';
    }
    var topRow =
      '<div class="rv-card__top">' +
        avatarHtml(r.customer_name) +
        '<div class="rv-card__top-info">' +
          '<div class="rv-card__top-name-row">' +
            '<span class="rv-card__author">' + esc(r.customer_name) + '</span>' +
            verified +
          '</div>' +
          dateHtml +
        '</div>' +
        '<div class="rv-card__top-stars">' + starsHtml(r.rating, 15) + '</div>' +
      '</div>';

    return '<div class="rv-card" data-review-id="' + r.id + '">' +
      topRow + productBadge + title + body + attrs + videoHtml + reply + helpful +
    '</div>';
  }

  /* ── Toggle "Read more" body expansion ─────────────────────────────── */
  window.rvToggleBody = function(btn) {
    var body = btn.previousElementSibling;
    var nowClamped = body.classList.toggle('rv-card__body--clamped');
    btn.textContent = nowClamped ? 'Read more' : 'Show less';
  };

  /* ── AI summary ─────────────────────────────────────────────────────── */
  window.rvLoadSummary = function (productId, api) {
    fetch((api || API) + '/api/reviews/summary/' + productId)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.summary) return;
        var el = document.getElementById('rv-summary-' + productId);
        var txt = document.getElementById('rv-summary-text-' + productId);
        var themes = document.getElementById('rv-themes-' + productId);
        if (!el) return;
        txt.textContent = data.summary;
        if (data.key_themes && data.key_themes.length) {
          themes.innerHTML = data.key_themes.map(function (t) {
            return '<span class="rv-theme-chip ' + (t.sentiment || 'neutral') + '">' + t.theme + '</span>';
          }).join('');
        }
        el.style.display = 'block';
      })
      .catch(function () {});
  };

  /* ── JSON-LD ─────────────────────────────────────────────────────────── */
  window.rvLoadJsonLd = function (productId, api) {
    var tag = document.getElementById('rv-jsonld-' + productId);
    if (!tag) return;
    var s = getState(productId);
    var idParam;
    if (s.groupId && s.groupId !== '0' && s.groupId !== '') {
      idParam = 'group_id=' + s.groupId;
    } else {
      var useCol = !s._productFallback &&
        (s.collectionId && s.collectionId !== '0' && s.collectionId !== '');
      idParam = useCol ? 'collection_id=' + s.collectionId : 'product_id=' + productId;
    }
    fetch((api || API) + '/api/reviews?' + idParam + '&per_page=1')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d.total) return;
        tag.textContent = JSON.stringify({
          '@context': 'https://schema.org/',
          '@type': 'Product',
          name: tag.dataset.productName,
          image: tag.dataset.productImage,
          url: tag.dataset.productUrl,
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: d.avg_rating,
            reviewCount: d.total,
            bestRating: 5,
            worstRating: 1,
          },
        });
      })
      .catch(function () {});
  };

  /* ── Filter / sort controls ─────────────────────────────────────────── */
  function _syncFilterBtns(productId, rating) {
    /* Sync toolbar star-rating buttons */
    document.querySelectorAll('#rv-widget-' + productId + ' .rv-filters .rv-filter-btn').forEach(function (b) {
      var oc = b.getAttribute('onclick') || '';
      var isAll  = rating === null && (oc.indexOf(', null,') > -1 || oc.indexOf(',null,') > -1);
      var isStar = rating !== null && oc.indexOf(',' + rating + ',') > -1;
      /* Skip photo/verified toggles — they manage their own active class */
      var isToggle = b.id && (b.id.indexOf('photo') > -1 || b.id.indexOf('verified') > -1);
      if (!isToggle) b.classList.toggle('active', !!(isAll || isStar));
    });
  }

  window.rvFilter = function (productId, rating, btn) {
    var s = getState(productId);
    s.rating = rating;
    s.page = 1;
    _syncFilterBtns(productId, rating);
    rvLoad(productId);
  };
  window.rvFilterPhoto = function (productId, btn) {
    var s = getState(productId);
    s.hasPhotos = !s.hasPhotos;
    s.page = 1;
    btn.classList.toggle('active', s.hasPhotos);
    rvLoad(productId);
  };
  window.rvFilterVerified = function (productId, btn) {
    var s = getState(productId);
    s.verifiedOnly = !s.verifiedOnly;
    s.page = 1;
    btn.classList.toggle('active', s.verifiedOnly);
    rvLoad(productId);
  };
  window.rvSort = function (productId, value) {
    var s = getState(productId);
    s.sort = value;
    s.page = 1;
    rvLoad(productId);
  };

  /* ── Helpful vote ───────────────────────────────────────────────────── */
  window.rvVoteHelpful = function (reviewId, isHelpful, api, btn) {
    btn.disabled = true;
    fetch((api || API) + '/api/reviews/' + reviewId + '/helpful', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ is_helpful: isHelpful }),
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var card = btn.closest('.rv-card');
        var btns = card.querySelectorAll('.rv-helpful-btn');
        btns[0].textContent = '👍 ' + d.helpful_count;
        btns[1].textContent = '👎 ' + d.not_helpful_count;
      })
      .catch(function () { btn.disabled = false; });
  };

  /* ── Inline review form (iframe) ────────────────────────────────────── */
  window.rvOpenForm = function (productId) {
    var panel = document.getElementById('rv-form-panel-' + productId);
    var iframe = document.getElementById('rv-form-iframe-' + productId);
    var widgetEl = document.getElementById('rv-widget-' + productId);
    if (!panel || !iframe) return;
    var api = (widgetEl && widgetEl.dataset.api) || API;
    if (!iframe.src || iframe.src === window.location.href) {
      iframe.src = api + '/api/reviews/form?token=direct&product_id=' + productId;
    }
    panel.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  };
  window.rvCloseForm = function (productId) {
    var panel = document.getElementById('rv-form-panel-' + productId);
    if (panel) panel.style.display = 'none';
    document.body.style.overflow = '';
  };

  /* ── Photo expand (quick lightbox) ─────────────────────────────────── */
  window.rvPhotoExpand = function (url, reviewId) {
    var lb = document.getElementById('rv-lightbox');
    if (!lb) return;
    document.getElementById('rv-lb-img').src = url;
    /* Populate review context if available */
    var reviewPanel = document.getElementById('rv-lb-review');
    if (reviewId && reviewPanel) {
      var card = document.querySelector('.rv-card[data-review-id="' + reviewId + '"]');
      if (card) {
        var author = card.querySelector('.rv-card__author');
        var body   = card.querySelector('.rv-card__body');
        var stars  = card.querySelector('.rv-stars');
        reviewPanel.innerHTML =
          (stars  ? '<div class="rv-lightbox__stars">' + stars.outerHTML + '</div>' : '') +
          (body   ? '<p class="rv-lightbox__body">'   + body.textContent  + '</p>'  : '') +
          (author ? '<div class="rv-lightbox__author">' + author.textContent + '</div>' : '');
        reviewPanel.style.display = 'flex';
      } else {
        reviewPanel.style.display = 'none';
      }
    } else if (reviewPanel) {
      reviewPanel.style.display = 'none';
    }
    lb.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  };

  /* ── Escape HTML ────────────────────────────────────────────────────── */
  function esc(str) {
    return String(str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
})();
